export default __webpack_public_path__ + "static/media/Image4Desktop.43f9d080.png";